function handlerMegaMenuHeight() {
	const nav = document.querySelector('.nav_wrapper')
	const innerNav = document.querySelector('.nav_wrapper .inner_nav')
	const header = document.querySelector('.header_annoucement_wrapper')

	if (!nav || !header) return

	function toggleNav(state, isMobile, isClickOutside) {
		if (state) {
			nav.classList.add(isMobile ? 'content_height_mobile' : 'content_height')
			nav.style.top = `${header.offsetHeight}px`

			if (isMobile) {
				setTimeout(() => {
					nav.style.height = 'auto'
					nav.style.maxHeight = `calc(100vh - ${header.offsetHeight}px)`
				}, 0)
			}
		} else {
			nav.classList.remove(isMobile ? 'content_height_mobile' : 'content_height')
			nav.style.top = ''

			if (isMobile) nav.style.height = 0
			if (isMobile && isClickOutside) handleClickHamburger()
		}
	}

	if (!isTablet()) {
		document.querySelectorAll('.nav-left li.shop-li, .shop-mega, .nav_wrapper').forEach(el => {
			el?.addEventListener('mouseenter', () => toggleNav(true, false))
			el?.addEventListener('mouseleave', () => toggleNav(false, false))
		})
	}

	if (isTablet()) {
		document.querySelector('.hamburger-ul')?.addEventListener('click', () => {
			toggleNav(!nav.classList.contains('content_height_mobile'), true)
		})

		document.addEventListener('click', function (event) {
			const isClickInside = innerNav.contains(event.target) || header.contains(event.target)

			if (!isClickInside && nav.classList.contains('content_height_mobile')) {
				toggleNav(false, true, true)
			}
		})
	}
}

const initSharedSweepsSettings = () => {
	if (window.__SS_SETTINGS_INIT__) return
	window.__SS_SETTINGS_INIT__ = true

	const config = window.SharedSweepsConfig || {}
	const token = config.token
	const shopDomain = config.shopDomain
	if (!token || !shopDomain || !window.fetch) return

	const storageKey = `sharedsweeps:settings:${shopDomain}`
	const cached = sessionStorage.getItem(storageKey)
	if (cached) {
		try {
			window.SharedSweepsSettings = JSON.parse(cached)
			return
		} catch (error) {
			sessionStorage.removeItem(storageKey)
		}
	}

	fetch('https://external-api-prod.sharedsweepsapp.com/products/settings/', {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
			'X-Shopify-Shop-Domain': shopDomain
		},
		credentials: 'omit'
	})
		.then((res) => {
			if (!res.ok) throw new Error(`Sharedsweeps settings request failed: ${res.status}`)
			return res.json()
		})
		.then((data) => {
			window.SharedSweepsSettings = data
			try {
				sessionStorage.setItem(storageKey, JSON.stringify(data))
			} catch (error) {
			}
		})
		.catch((error) => {
			console.warn('[SharedSweeps] settings error', error)
		})
}

const initSharedSweepsCartEntries = () => {
	if (window.__SS_AJAX_CART_ENTRIES__) return
	window.__SS_AJAX_CART_ENTRIES__ = true

	const safeParsePrice = (text) => {
		if (!text) return 0
		let t = text.replace(/[^0-9,.\-]/g, '').trim()
		if (t.includes(',') && t.includes('.')) {
			const lc = t.lastIndexOf(',')
			const ld = t.lastIndexOf('.')
			t = lc > ld ? t.replace(/\./g, '').replace(',', '.') : t.replace(/,/g, '')
		} else if (t.includes(',')) {
			t = t.replace(',', '.')
		}
		const n = parseFloat(t)
		return Number.isNaN(n) ? 0 : n
	}

	const getCartTotal = () => {
		const totalEl = document.querySelector('#ajax-total, .drawer__footer .totals .totals__total-value, .totals .totals__total-value, .cart__footer .totals__total-value')
		const totalValue = safeParsePrice(totalEl?.textContent || '')
		if (totalValue > 0) return totalValue

		const sawEl = document.querySelector('.drawer__footer .saw-cart-total, .saw-cart-total')
		const sawValue = safeParsePrice(sawEl?.textContent || '')
		return sawValue
	}

	const getBonusEntries = (cartTotal) => {
		const thresholds = window.SharedSweepsSettings?.activeBonusEntryThresholds
		if (!Array.isArray(thresholds) || cartTotal <= 0) return 0

		const now = Date.now()
		const bonusTotal = thresholds.reduce((sum, entry) => {
			const subtotal = Number(entry?.subtotal)
			const bonus = Number(entry?.bonusEntries)
			if (!Number.isFinite(subtotal) || !Number.isFinite(bonus)) return sum
			if (cartTotal < subtotal) return sum

			const start = entry?.startDate ? Date.parse(entry.startDate) : null
			const end = entry?.endDate ? Date.parse(entry.endDate) : null
			if ((start && now < start) || (end && now > end)) return sum

			return sum + bonus
		}, 0)
		return bonusTotal
	}

	const getBaseEntries = (el) => {
		if (!el) return 0
		const cached = parseInt(el.dataset.ssBaseEntries, 10)
		if (!Number.isNaN(cached)) return cached
		const parsed = parseInt(String(el.textContent || '').replace(/[^\d]/g, ''), 10)
		const base = Number.isNaN(parsed) ? 0 : parsed
		el.dataset.ssBaseEntries = String(base)
		return base
	}

	const applyBonusEntries = () => {
		const cartTotal = getCartTotal()
		const bonusEntries = getBonusEntries(cartTotal)
		const targets = document.querySelectorAll('.sharedsweeps-cart-total-wrapper .ss-rg-value.ss-ce-value, .ss-ce-total .ss-rg-value.ss-ce-value')
		if (!targets.length) return

		targets.forEach((target) => {
			const baseEntries = getBaseEntries(target)
			const nextValue = baseEntries + bonusEntries
			const nextText = String(nextValue)
			if (target.textContent !== nextText) target.textContent = nextText
		})
	}

	const updateAjaxEntries = () => {
		const ajaxCart = document.querySelector('.ajax-cart')
		if (ajaxCart) {
			const values = ajaxCart.querySelectorAll('.ss-cart-value')
			if (values.length) {
				let total = 0
				values.forEach((el) => {
					total += safeParsePrice(el.textContent)
				})

				const target = document.querySelector('.ajax-checkout .ss-rg-value.ss-ce-value')
				if (target) {
					const nextValue = String(Math.floor(total))
					if (target.textContent !== nextValue) target.textContent = nextValue
					target.dataset.ssBaseEntries = nextValue
				}
			}
		}

		applyBonusEntries()
	}

	let drawerObserver = null
	let bodyObserver = null
	let lastDrawer = null
	let rafPending = false

	const scheduleUpdate = () => {
		if (rafPending) return
		rafPending = true
		requestAnimationFrame(() => {
			rafPending = false
			updateAjaxEntries()
		})
	}

	const attachDrawerObserver = (drawer) => {
		if (!drawer || !('MutationObserver' in window)) return
		if (drawerObserver) drawerObserver.disconnect()

		drawerObserver = new MutationObserver(() => {
			scheduleUpdate()
		})
		drawerObserver.observe(drawer, { childList: true, subtree: true, characterData: true })
	}

	const ensureDrawerObserver = () => {
		const drawer = document.getElementById('cart-drawer')
		if (!drawer) return
		if (drawer !== lastDrawer) {
			lastDrawer = drawer
			attachDrawerObserver(drawer)
		}
		scheduleUpdate()
	}

	const attachBodyObserver = () => {
		if (bodyObserver || !('MutationObserver' in window)) return
		bodyObserver = new MutationObserver((mutations) => {
			const hasDrawerMutation = mutations.some((mutation) => {
				const nodes = [...mutation.addedNodes, ...mutation.removedNodes]
				return nodes.some((node) => {
					if (node.nodeType !== 1) return false
					if (node.id === 'cart-drawer') return true
					return typeof node.querySelector === 'function' && node.querySelector('#cart-drawer')
				})
			})

			if (hasDrawerMutation) ensureDrawerObserver()
		})
		bodyObserver.observe(document.body, { childList: true, subtree: true })
	}

	const init = () => {
		ensureDrawerObserver()
		attachBodyObserver()
		document.addEventListener('cart:updated', scheduleUpdate)
		document.addEventListener('cart:refresh', scheduleUpdate)
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init)
	} else {
		init()
	}
}

initSharedSweepsSettings()
initSharedSweepsCartEntries()

handlerMegaMenuHeight()

//help hover
$(".nav-right li.help-li, .help-mega").hover(function () {
	$(this).children("a").addClass("hover-a");

	const isHelp = $(this).attr("data-is-help");

	if (isHelp) {
		$(".help-mega").stop().fadeIn("fast");
	}
}, function () {
	$(this).children("a").removeClass("hover-a");

	const isHelp = $(this).attr("data-is-help");

	if (isHelp) {
		$(".help-mega").fadeOut('fast');
	}
});

$(".help-mega").hover(function () {
	$(".nav-right li.help-li[data-is-help]").children("a").addClass("hover-a");
	$(".help-mega").stop().fadeIn("fast");
}, function () {
	$(".nav-right li.help-li[data-is-help]").children("a").removeClass("hover-a");
	$(".help-mega").fadeOut('fast');
});

//banner click
$("#banner").on("click", function () {
	var url = $(this).attr("banner-url");
	window.location.href = url;
});

$("[data-featured-grid]").on("click", function () {
	var url = $(this).attr("data-featured-grid");
	if (url != '' && url != undefined && url != null) {
		window.location.href = url;
	}
});

$('[data-image-with-text]').on('click', function () {
	const $url = $(this).attr('data-image-with-text')
	if ($url) window.location.href = $url
})


//featured prod
$(".box .img, .big-box .img").on("click", function () {
	var url = $(this).attr("box-url");
	window.location.href = url;
});


$(".box-slide").slick({
	infinite: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: true,
	dots: false,
	cssEase: 'linear',
	variableWidth: true,
	centerMode: false,
});

$(".ambassador-grid-ul").slick({
	infinite: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	dots: true,
	cssEase: 'linear',
	variableWidth: true,
	centerMode: false,
	appendDots: $("div.ambassador-grid-dots")
});

// arrival slider
$(document).ready(function () {
	$(".arrival_slider").slick({
		infinite: false,
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		cssEase: 'linear',
		variableWidth: false,
		centerMode: false,
		touchThreshold: 100,
		prevArrow: '<button id="btn_prev"><svg class="arrival_prevArrow" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M20 5.00004C20.265 5.00364 20.5192 5.10618 20.7125 5.28754C20.9003 5.47713 21.0056 5.73319 21.0056 6.00004C21.0056 6.26689 20.9003 6.52294 20.7125 6.71254L11.4125 16L20.7125 25.2875C20.872 25.4818 20.9534 25.7285 20.9411 25.9795C20.9288 26.2306 20.8235 26.4681 20.6458 26.6458C20.468 26.8236 20.2306 26.9288 19.9795 26.9412C19.7284 26.9535 19.4818 26.872 19.2875 26.7125L9.28749 16.7125C9.09971 16.5229 8.99436 16.2669 8.99436 16C8.99436 15.7332 9.09971 15.4771 9.28749 15.2875L19.2875 5.28754C19.4808 5.10618 19.7349 5.00364 20 5.00004Z" fill="black"/></svg></button>',
		nextArrow: '<button id="btn_next"><svg class="arrival_nextArrow" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M12 27C11.735 26.9964 11.4808 26.8938 11.2875 26.7125C11.0997 26.5229 10.9944 26.2668 10.9944 26C10.9944 25.7331 11.0997 25.4771 11.2875 25.2875L20.5875 16L11.2875 6.71246C11.128 6.51817 11.0466 6.2715 11.0589 6.02045C11.0712 5.7694 11.1765 5.53191 11.3542 5.35417C11.532 5.17644 11.7694 5.07117 12.0205 5.05884C12.2716 5.04651 12.5182 5.128 12.7125 5.28746L22.7125 15.2875C22.9003 15.4771 23.0056 15.7331 23.0056 16C23.0056 16.2668 22.9003 16.5229 22.7125 16.7125L12.7125 26.7125C12.5192 26.8938 12.2651 26.9964 12 27Z" fill="black"/></svg></button>',
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: false,
					dots: false,
					variableWidth: false
				}
			},
			{
				breakpoint: 500,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: false,
					dots: false,
					variableWidth: false
				}
			}
		]
	});

	var prdCount = $(".product-slide-ul").data('products-length') < 5 ? $(".product-slide-ul").data('products-length') : 5;
	$(".product-slide-ul").slick({
		infinite: false,
		slidesToShow: prdCount,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		cssEase: 'linear',
		variableWidth: false,
		centerMode: false,
		touchThreshold: 100,
		prevArrow: '<button class="slider_prev_btn"><svg width="25" height="8" viewBox="0 0 25 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.140583 3.6466C-0.0471093 3.84186 -0.0471093 4.15844 0.140583 4.3537L3.2002 7.53568C3.38799 7.73094 3.69241 7.73094 3.8801 7.53568C4.06789 7.34042 4.06789 7.02384 3.8801 6.82858L1.16049 4.00015L3.8801 1.17172C4.06789 0.976456 4.06789 0.659876 3.8801 0.464616C3.69241 0.269346 3.38799 0.269346 3.2002 0.464616L0.140583 3.6466ZM24.519 3.50015L0.480582 3.50015L0.480582 4.50015L24.519 4.50015L24.519 3.50015Z" fill="black"></path></svg></button>',
		nextArrow: '<button class="slider_next_btn"><svg width="25" height="8" viewBox="0 0 25 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.3785 4.35365C24.5662 4.15839 24.5662 3.84181 24.3785 3.64655L21.3188 0.464562C21.1311 0.2693 20.8266 0.2693 20.6389 0.464562C20.4512 0.659824 20.4512 0.976407 20.6389 1.17167L23.3586 4.0001L20.6389 6.82853C20.4512 7.02379 20.4512 7.34037 20.6389 7.53563C20.8266 7.7309 21.1311 7.7309 21.3188 7.53563L24.3785 4.35365ZM0 4.5001H24.0385V3.5001H0V4.5001Z" fill="black"></path></svg></button>',
		responsive: [
			{
				breakpoint: 769,
				settings: "unslick"
			}
		]
	});
})

$(".slide-ul-landing").slick({
	infinite: false,
	slidesToShow: 4,
	slidesToScroll: 1,
	arrows: true,
	dots: false,
	cssEase: 'linear',
	variableWidth: false,
	centerMode: false,
	touchThreshold: 100,
	prevArrow: $("button.btn-fcs-prev"),
	nextArrow: $("button.btn-fcs-next"),
	responsive: [
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
				infinite: false,
				dots: false,
				variableWidth: true
			}
		}
	]
});

$(".slide-ul").slick({
	infinite: false,
	slidesToShow: 5,
	slidesToScroll: 1,
	arrows: true,
	dots: false,
	cssEase: 'linear',
	variableWidth: false,
	centerMode: false,
	touchThreshold: 100,
	prevArrow: $("button.btn-fcs-prev"),
	nextArrow: $("button.btn-fcs-next"),
	responsive: [
		{
			breakpoint: 769,
			settings: "unslick"
		}
	]
});
$(".cat-shop-ul").slick({
	infinite: false,
	slidesToShow: 3,
	slidesToScroll: 1,
	arrows: true,
	dots: false,
	cssEase: 'linear',
	variableWidth: true,
	centerMode: false,
	prevArrow: $("button.btn-cat-prev"),
	nextArrow: $("button.btn-cat-next"),
	responsive: [
		{
			breakpoint: 1200,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1,
				infinite: false,
				dots: false,
				variableWidth: false,
				centerMode: false
			}
		},
		{
			breakpoint: 992,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1,
				infinite: false,
				dots: false,
				variableWidth: false,
				centerMode: false
			}
		},
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: false,
				dots: true,
				variableWidth: true,
				centerMode: false
			}
		}
	]
});

$(".image-parent").slick({
	infinite: false,
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: true,
	dots: true,
	cssEase: 'linear',
	variableWidth: false,
	centerMode: false,
	prevArrow: $("button.btn-it-prev"),
	nextArrow: $("button.btn-it-next")
});
$(".insta-slider").slick({
	infinite: false,
	slidesToShow: 2,
	slidesToScroll: 1,
	arrows: true,
	dots: false,
	cssEase: 'linear',
	variableWidth: true,
	centerMode: false,
	prevArrow: $("button.btn-insta-prev"),
	nextArrow: $("button.btn-insta-next"),
	responsive: [
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: false,
				dots: false,
				variableWidth: true,
				centerMode: false
			}
		}
	]
});

//ship-slider
if ($('.ship-slider')) {
	$('.ship-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: false,
		infinite: false,
		speed: 1000,
		nav: true,
		dots: true,
		autoplay: true,
		autoplaySpeed: 6000,
		speed: 600
	});
}

//review-slider
$('.review_slider_wrapper').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	fade: false,
	infinite: false,
	speed: 1000,
	nav: true,
	dots: true,
	autoplay: true,
	autoplaySpeed: 3000,
	speed: 600
});

// Carousel Quotes
$('.carousel-quotes-ul').slick({
	centerMode: true,
	slidesToShow: 3,
	arrows: false,
	fade: false,
	infinite: true,
	speed: 1000,
	nav: true,
	dots: true,
	autoplay: false,
	responsive: [
		{
			breakpoint: 492,
			settings: {
				slidesToShow: 1,
				centerMode: false
			}
		}
	]
});

//announcement-bar-slider
$('#announcement').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	fade: false,
	infinite: true,
	nav: true,
	dots: false,
	autoplay: true,
	autoplaySpeed: 6000,
	speed: 600,
	vertical: true,
	verticalSwiping: true
});

$('#second-announcement').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	fade: false,
	infinite: true,
	nav: true,
	dots: false,
	autoplay: true,
	autoplaySpeed: 6000,
	speed: 600,
	vertical: true,
	verticalSwiping: true
});


let isDots = false;
let isArrows = false;
let isAutoPlay = false;

if (document.querySelector(".hero-slider") != null) {
	if (document.querySelector('[data-slider-autoplay]').dataset.sliderAutoplay == 'true') {
		isAutoPlay = true;
	}
	var autoPlaySpeed = document.querySelector('[data-autoplay-speed]').dataset.autoplaySpeed.toString() + '000';
	if (document.querySelector('[data-total-blocks]').dataset.totalBlocks > 1) {
		isDots = true;
		isArrows = true;
	}

	$(".hero-slider").slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: isArrows,
		dots: isDots,
		cssEase: 'linear',
		variableWidth: false,
		centerMode: false,
		prevArrow: $(".btn-banner-prev"),
		nextArrow: $(".btn-banner-next"),
		autoplay: isAutoPlay,
		autoplaySpeed: autoPlaySpeed,
		fade: true
	});
	if (window.innerWidth < 990) {
		$('.hero-slider').on('touchcancel touchmove', e => {
			$(".hero-slider").slick('slickPlay');
		});
		document.querySelectorAll("[prev-next-btn]").forEach((btn) => {
			btn.addEventListener("click", () => {
				$(".hero-slider").slick('slickPause');
			});
		});
	}
}


// pdp accordion
$(document).ready(function () {
	// PDP Accordion
	$(document).on('click', '.feature_Accordion .description .description_upper_content', function () {
		$(this).siblings(".desc").toggleClass("show");
		$(this).children(".accordion_icon").children(".plus_icon").toggleClass("hide");
		$(this).children(".accordion_icon").children(".minus_icon").toggleClass("show");

	})

	// new Navbar

	$(document).on('click', '.nav_wrapper .inner_nav .new_nav_men_megamenu .new_nav_men_submenu_section .new_nav_men_submenu.accordion-mode .title_and_icon_wrapper', function () {
		$(this).siblings(".nav_submenu_list").toggleClass("show");

		$(this).children(".accordion_icon").children(".plus_icon").toggleClass("hide");
		$(this).children(".accordion_icon").children(".minus_icon").toggleClass("show");

	})

	$('.nav_wrapper .inner_nav .men_women_toggle_wrapper .men_women_toggle .men_toggle').addClass('selected_menu');

	$(document).on('click', '.nav_wrapper .inner_nav .men_women_toggle_wrapper .men_women_toggle .men_toggle, .nav_wrapper .inner_nav .men_women_toggle_wrapper .men_women_toggle .women_toggle', function () {
		$('.nav_wrapper .inner_nav .men_women_toggle_wrapper .men_women_toggle .men_toggle, .nav_wrapper .inner_nav .men_women_toggle_wrapper .men_women_toggle .women_toggle').removeClass("selected_menu");
		$(this).addClass("selected_menu");
		if ($(this).text().trim() == "Men") {
			$('#women_menu').removeClass('show');
			$('#men_menu').removeClass('hide');

			$('.men_review').removeClass('hide');
			$('.women_review').removeClass('show');

		} else {
			$('#men_menu').addClass('hide');
			$('#women_menu').removeClass('hide');
			$('#women_menu').addClass('show');

			$('.women_review').addClass('show');
			$('.men_review').addClass('hide');
		}
	})
})

//product size chart
$(document).ready(function () {

	const sizeInnerEls = document.querySelectorAll('.size-inner[data-coll-name]')

	if (sizeInnerEls.length > 0) {
		sizeInnerEls.forEach(el => {
			const sizeChartButtonActiveEl = el.querySelector('.c-modalSizeChart1__button--isActive')

			if (sizeChartButtonActiveEl) {
				const activeSize = sizeChartButtonActiveEl.dataset.sizeToggle
				const dataSizeEls = el.querySelectorAll('[data-size]')

				dataSizeEls.forEach(sizeEl => {
					const dataSizeVal = sizeEl.getAttribute('data-size')
					if (dataSizeVal !== activeSize) sizeEl.style.display = 'none'
				})
			}
		})
	} else {
		const sizeChartButtonActiveEl = document.querySelector('.c-modalSizeChart1__button--isActive')

		if (sizeChartButtonActiveEl) {
			const activeSize = sizeChartButtonActiveEl.dataset.sizeToggle
			const dataSizeEls = document.querySelectorAll('[data-size]')

			dataSizeEls.forEach(sizeEl => {
				const dataSizeVal = sizeEl.getAttribute('data-size')
				if (dataSizeVal !== activeSize) sizeEl.style.display = 'none'
			})
		}
	}
})

$(document).on('click', '[data-size-toggle]', function () {
	const $parent = $(this).closest('.c-modalSizeChart1')
	const size = $(this).data('size-toggle')

	$parent.find('[data-size-toggle]').removeClass('c-modalSizeChart1__button--isActive')
	$(this).addClass('c-modalSizeChart1__button--isActive')

	$parent.find('[data-size]').hide()
	$parent.find('[data-size="' + size + '"]').show()
})

$(document).on('click', '#size', function (e) {
	e.preventDefault();

	const el = e.target
	const id = el.getAttribute('data-size-chart-id')

	if (id) {
		const sizeChartContents = document.querySelectorAll(`#sizechart div[data-size-chart-id]`)

		if (sizeChartContents.length) {
			sizeChartContents.forEach(el => {
				el.style.display = 'none'
			})
		}

		const currentSizeChartContent = document.querySelector(`#sizechart div[data-size-chart-id="${id}"]`)
		if (currentSizeChartContent) currentSizeChartContent.style.display = 'block'
	}

	$("#sizechart").toggleClass("is-visible");
	$("body").toggleClass("body-size");
});

$(document).on('click', "#sizechart .modal-close", function () {
	$("#sizechart").toggleClass("is-visible");
	$("body").toggleClass("body-size");
});


$(document).on("click", "#notify-me-btn, #sticky-notify-me-btn", function (e) {
	e.preventDefault();
	$("#notify-me-modal").toggleClass("is-visible");
	$("body").toggleClass("body-size");
});

$(document).on('click', "#notify-me-modal .modal-close", function () {
	resetModalNotify()
	$("#notify-me-modal").toggleClass("is-visible");
	$("body").toggleClass("body-size");
});

function resetModalNotify() {
	const button = document.querySelector('#notify-me-button')
	const errorEl = document.querySelector('#notify-me-error')

	button.classList.remove('loading')
	button.classList.remove('success')

	errorEl.style.display = 'none'

	document.getElementById("notify-me-form").reset();
}

$('#help-mobile-menu ul li').on('click', function (e) {
	e.stopPropagation();

	const liValue = $(this).text();

	$(this).parent().siblings('#help-text').text(liValue);
	$('.dropdown-option').slideUp();
	$('#help-text').removeClass('active');
	$('.dropdown-icon').removeClass('rotate');
});

//sizechart
//tabs
$('.measure-tabs span').click(function (e) {

	e.stopPropagation();

	const liValue = $(this).text();
	$(this).parent().siblings('#help-text__size-chart').text(liValue);

	$('#help-mobile-menu__size-chart .dropdown-option').slideUp();
	$('#help-mobile-menu__size-chart #help-text__size-chart').removeClass('active');
	$('#help-mobile-menu__size-chart .dropdown-icon').removeClass('rotate');

	// Check for active
	$('.measure-tabs li').removeClass('measure-active');
	$(this).parent().addClass('measure-active');

	// Display active tab
	let currentTab = $(this).attr('data-tab');

	if (currentTab !== undefined) {
		let activeTxt = document.querySelector('#measure-tabs-section').querySelector(`[data-tab=${currentTab}]`).innerText;
		document.querySelector('#help-mobile-menu__size-chart #help-text__size-chart').innerText = activeTxt;
	}
	$('.measure-tab-contents .wrapper').hide();
	$("#" + currentTab).show();
	return false;
});

$(".sub-heads").on("swipe", function (event, slick, direction) {
	if (slick["currentSlide"] == 0) {
		$(".sub-images .buzzfeed-img img").click();
	} else if (slick["currentSlide"] == 1) {
		$(".sub-images .us-week-img img").click();
	}
});

//mobile dropdown
$('#help-text').on('click', function (e) {
	e.stopPropagation();
	if ($(this).siblings('ul').is(':visible')) {
		$(this).siblings('ul').slideUp();
		$(this).siblings(".dropdown-icon").removeClass('rotate');
	} else {
		$(this).siblings('ul').slideDown();
		$(this).siblings('#help-text').addClass('active');
		$(this).siblings(".dropdown-icon").addClass('rotate');
	}
});

$('#help-text__size-chart').on('click', function (e) {
	e.stopPropagation();
	if ($(this).siblings('ul').is(':visible')) {
		$(this).siblings('ul').slideUp();
		$(this).siblings(".dropdown-icon").removeClass('rotate');
	} else {
		$(this).siblings('ul').slideDown();
		$(this).siblings('#help-text__size-chart').addClass('active');
		$(this).siblings(".dropdown-icon").addClass('rotate');
	}
});

$('#help-content .c-button').on('click', function () {
	if ($('#links-accordions .link-none-block').length) {
		$('#links-accordions .link-none-block').each((i, ele) => {
			$(ele).removeClass('d-none');
		});
		if ($('.help-boxes .c-button').length) {
			$('.help-boxes .c-button').addClass('d-none');
		}
	}
	if ($('#links-accordions .link-heading.d-none').length) {
		$('#links-accordions .link-heading.d-none').each((i, ele) => {
			$(ele).removeClass('d-none');
		});
	}
});

$('.link-title').on('click', function () {
	if ($(this).hasClass('active')) {
		$(this).removeClass('active');
		$(this).children('svg').find('path:nth-child(2)').show();
		$(this).siblings('.link-content').slideUp();
	} else {
		$('.link-title').removeClass('active');
		$('.link-title').children('svg').find('path:nth-child(2)').show();
		$('.link-content').slideUp();

		$(this).addClass('active');
		$(this).children('svg').find('path:nth-child(2)').hide();
		$(this).siblings('.link-content').slideDown();
	}
});

$(".hamburger-ul").click(function () {
	handleClickHamburger()
});


function handleClickHamburger() {
	$(".burger-open").toggleClass("opac-0");
	$(".burger-close").toggleClass("opac-1");
	// $("#hamburger-menu").toggleClass("nav-list-active");
	// $(".nav_wrapper").fadeOut("fast");
	//$(".nav_wrapper").toggleClass("content_height_mobile");
	$("body").toggleClass("body-over");
	let widgetUI = setInterval(() => {
		if (document.querySelectorAll('access-widget-ui').length > 0) {
			document.querySelectorAll('access-widget-ui').forEach((ele) => {
				if (ele.shadowRoot.querySelector("button[part='acsb-trigger']") != null) {
					ele.shadowRoot.querySelector("button[part='acsb-trigger']").classList.toggle("hide");
				}
			});
			clearInterval(widgetUI);
		} else {
			setTimeout(() => {
				clearInterval(widgetUI);
			}, 10000);
		}
	}, 10);

	let gorgiasChat = setInterval(() => {
		if (document.querySelector("#gorgias-chat-container") != null) {
			document.querySelector("#gorgias-chat-container").classList.toggle("hidden");
			clearInterval(gorgiasChat);
		} else {
			setTimeout(() => {
				clearInterval(gorgiasChat);
			}, 10000);
		}
	}, 10);
}

//bundle add to cart
window.bundleAddtocart = async function (items) {
	handleSummaryBuildLoading(true)

	const data = []
	// handle duplicates, cart api is not handling it well
	for (const item of items) {
		const repeat = data.find((v) => v.id === item.id)
		if (repeat) {
			repeat.qty++
		} else {
			data.push({
				qty: item.quantity,
				id: item.id,
				selling_plan: item.selling_plan || undefined,
			})
		}
	}

	const initTapcart = window.Tapcart?.isInitialized // is mobile app

	if (initTapcart) {
		TapcartAddToCart(data)
	} else {
		const response = await window.FctApp.cart.addToCart(data)
		opendrawer()
	}

	handleSummaryBuildLoading(false)
}

function TapcartAddToCart(data = []) {
	const TapcartData = []

	data.forEach(e => {
		TapcartData.push({
			quantity: e.qty,
			variantId: e.id
		})
	})

	window.Tapcart.actions.addToCart({
		lineItems: [...TapcartData]
	})

	window.Tapcart.actions.openScreen({
		destination: {type: 'internal', url: '/cart'}
	})
}

//addtocart
async function addtocart(id, qty, prodID, isSellingPlan, saveScroll = true, membershipSellingPlanID = '', doNotOpenDrawer = false){

	handleAddToCartLoading(true)

	const cart = window.FctApp.cart
	let sellingPlanID;
	let isSubscriptionSelected = false;

	if (isSellingPlan == "true") {
		sellingPlanID = document.querySelector(".selling-plan-container .selling-plans").value;
		if (document.querySelectorAll(".subscription_frequancy .radio__input").length) {
			document.querySelectorAll(".subscription_frequancy .radio__input").forEach((radio) => {
				if (radio.checked) {
					if (radio.value == "subscription") {
						isSubscriptionSelected = true;
					}
				}
			});
		}
	}
	const data = {
		id,
		qty,
		selling_plan: isSellingPlan == "true" && isSubscriptionSelected ? sellingPlanID : ""
	}
	if (!prodID && membershipSellingPlanID) {
		data.selling_plan = membershipSellingPlanID
	}
	try {
		const response = await cart.addToCart([data], prodID, membershipSellingPlanID)
		renderContents({parsedState: response, state: 'Added Products', saveScroll});
	} catch (e) {
		console.error(e);
	} finally {
		if (!doNotOpenDrawer) opendrawer();

		handleAddToCartLoading(false)

		// It is unclear why this is necessary
		/*$(".select-dropdown .select-selected").on("click", function(e){
			e.stopPropagation();
			 $(this).closest('.cart-item-box').siblings('.cart-item-box').find('.select-items').addClass("select-hide");
			if($(this).siblings(".select-items").is(':visible')){
				$(this).siblings(".select-items").addClass("select-hide");
			}else{
				$(this).siblings(".select-items").removeClass("select-hide");
			}

		});*/

		$(document).on("click", function (e) {
			e.stopPropagation();
			$(".select-items").addClass("select-hide");
		});
		var var_id = "";
		$(".select-items div").on("click", function () {
			var text = $(this).text();
			var_id = $(this).attr("value");

			$(".select-items div").each(function () {
				if ($(this).hasClass("same-as-selected")) {
					$(this).removeClass("same-as-selected");
				}
			});
			$(this).addClass("same-as-selected");
			$(this).parent().siblings(".select-selected").text(text).attr("variant-id", var_id);
			$(this).parent().addClass("select-hide");

			$(this).parent().parent().siblings(".select-size").children(".select-size-btn").hide();
			$(this).parent().parent().siblings(".select-size").children(".select-add-btn").text("Add To Cart").css({"background-color": "#242424", "border-color": "#242424"});
			$(this).parent().parent().siblings(".select-size").children(".select-add-btn").show();
			return false;
		});

		$(".select-add-btn").on('click', function (e) {
			e.preventDefault();
			addtocart(var_id, 1, '', '', false);
			$(this).html('<span class="check-svg"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.99826.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" fill="currentColor"></path></svg></span><span>Added To Cart</span>').css({
				"background-color": "#8D8D8C",
				"border-color": "#8D8D8C"
			});
		});
	}
	// submitButton.classList.remove('loading');
	// if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
	// if (!this.error) submitButton.removeAttribute('aria-disabled');
	// submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
}

function renderContents({parsedState, state, saveScroll}) {

	// save cart-form scroll
	const cartForm = document.querySelector('#cart-form')
	const cartFormScrollTop = cartForm?.scrollTop || 0

	if (saveScroll) {
		// set cart-form after render scroll
		const cartFormAfterRender = document.querySelector('#cart-form')
		if (cartFormAfterRender) cartFormAfterRender.scrollTop = cartFormScrollTop
	}
}

function getSectionsToRenderCart() {
	return [
		{
			id: 'cart-drawer',
			section: document.getElementById('cart-drawer').dataset.id,
			selector: '.cart-drawer'
		}
	];
}

function opendrawer() {
	window.savedScrollY = window.scrollY

	$("body").addClass("cart-over");
	$("html").addClass("cart-over");
	$("#cart-drawer").addClass("is-open");
	$("#cart-overlay").addClass("is-visible");
}

$(".select-dropdown.bundle .select-selected, .select-dropdown.facets .select-selected").on("click", function (e) {
	e.stopPropagation();
	if ($(this).siblings(".select-items").is(':visible')) {
		$(this).siblings(".select-items").addClass("select-hide");
	} else {
		$(this).siblings(".select-items").removeClass("select-hide");
	}
});

// collection page size swatches quick shop start
function insertSwatches() {
	let temp_length = "";

	$("li.grid .collectSelect option").each(function () {
		var option_value = $(this).val();
		var option_text = $(this).text();
		var option_text1 = $(this).text();
		var option_stock = $(this).attr("stock");
		const options = option_text.split(" / ")

		if (options.length === 3 && option_text.includes('Tall')) return

		if (option_text.includes(" / ")) {
			var option_value_split = option_text.split(" / ");
			if (option_value_split[1] == "Small" || option_value_split[1] == "small") {
				option_value_split[1] = "S";
			} else if (option_value_split[1] == "Medium" || option_value_split[1] == "medium") {
				option_value_split[1] = "M";
			} else if (option_value_split[1] == "Large" || option_value_split[1] == "large") {
				option_value_split[1] = "L";
			} else if (option_value_split[1] == "XLarge" || option_value_split[1] == "Xlarge" || option_value_split[1] == "xlarge" || option_value_split[1] == "xLarge") {
				option_value_split[1] = "XL";
			} else if (option_value_split[1] == "2XLarge" || option_value_split[1] == "2xlarge" || option_value_split[1] == "2xLarge" || option_value_split[1] == "2Xlarge") {
				option_value_split[1] = "2XL";
			} else if (option_value_split[1] == "3XLarge" || option_value_split[1] == "3xlarge" || option_value_split[1] == "3xLarge" || option_value_split[1] == "3Xlarge") {
				option_value_split[1] = "3XL";
			} else if (option_value_split[1] == "4XLarge" || option_value_split[1] == "4xlarge" || option_value_split[1] == "4xLarge" || option_value_split[1] == "4Xlarge") {
				option_value_split[1] = "4XL";
			} else if (option_value_split[1] == "5XLarge" || option_value_split[1] == "5xlarge" || option_value_split[1] == "5xLarge" || option_value_split[1] == "5Xlarge") {
				option_value_split[1] = "5XL";
			} else if (Number(option_value_split[0])) {
				option_value_split[1] = option_value_split[0]
			} else {
				option_value_split[1];
			}

			if ((option_value_split[0] === "crew") || (option_value_split[0] === "Crew")) {
				var sw_parent = $(this).parent().siblings(".pack-size-swatch-main").find(".swatch-crew-tab");
				//on collection page
				$(sw_parent).append(`
						<div variant-id="${option_value}" class="pack-product swatch-box ${option_stock}">
							<span>${option_value_split[1]}</span>
						</div>
					`);
			} else if ((option_value_split[0] === "v-neck") || (option_value_split[0] === "V-Neck") || (option_value_split[0] === "V-neck") || (option_value_split[0] === "v-Neck")) {
				var sw_parent = $(this).parent().siblings(".pack-size-swatch-main").find(".swatch-v-neck-tab");
				//on collection page
				$(sw_parent).append(`
						<div variant-id="${option_value}" class="pack-product swatch-box ${option_stock}">
							<span>${option_value_split[1]}</span>
						</div>
					`);
			} else if (Number(option_value_split[0])) {
				var optionl_text2 = option_value_split[1] ? option_value_split[0] : option_text1;

				if (temp_length !== optionl_text2) {
					var sw_parent = $(this).parent().siblings(".pack-size-swatch-main").find(".swatch-crew-tab");
					//on collection page
					$(sw_parent).append(`
									<div variant-id="${option_value}" class="pack-product swatch-box ${option_stock}">
										<span>${option_value_split[0]}</span>
									</div>
								`);
					temp_length = option_value_split[1] ? option_value_split[0] : option_text1;
				}
			}
		}
	});
}

insertSwatches()

//pack swatches quickshop
$(document).on("click", ".pack-boxes-swatch-main .pack-swatch", function () {
	// Check for active
	$(".pack-size-swatch-main").removeClass("swatch-visible");
	$(".pack-size-swatch-main .swatch-boxes-ul").removeClass("active-pack");
	$(this).parent().addClass("active-pack");

	// Display active tab
	let currtab = $(this).attr("data-tab");

	var pack_click = $(this).parent().parent().siblings(".pack-size-swatch-main").find(".swatch-" + currtab + "-tab");
	$(this).parent().parent().siblings(".pack-size-swatch-main").children(".swatch-boxes-ul").hide();
	$(this).parent().parent().siblings(".pack-size-swatch-main").addClass("swatch-visible");
	$(this).parent().parent().siblings(".pack-size-swatch-main").find(".swatch-" + currtab + "-tab").show();
	return false;
});


$(document).on('click', ".single-product, .pack-product", function () {
	var id = $(this).attr("variant-id");
	var membershipID = $(this).attr("membership-pack-id") || $(this).parent().attr("membership-pack-id");
	var membershipSellingPlanID = $(this).attr("membership-selling-plan-id") || $(this).parent().attr("membership-selling-plan-id");
	var freegiftID = $(this).attr('free-gift-id') || $(this).parent().attr('free-gift-id');
	var isMembershipAddToCart = $(this).attr("data-membership-add-to-cart");

	if (membershipID) {
		addtocart(id,1,membershipID, '', isMembershipAddToCart !== 'true', membershipSellingPlanID);
	} else {
		if (freegiftID) {
			addtocart(id, 1, freegiftID, '', isMembershipAddToCart !== 'true');
		} else {
			addtocart(id, 1, '', '', isMembershipAddToCart !== 'true', membershipSellingPlanID);
		}
	}

	if (isMembershipAddToCart) handleMembershipButton('disable')
});

$(document).on("mouseleave", "li.grid", function () {
	$(this).find(".swatch-boxes-main").removeClass("swatch-visible");

	$(".length-variant-main").removeClass("swatch-visible");
	$(".length-variant-wrapper").removeClass("swatch-visible");

	$(".pack-size-swatch-main .swatch-crew-tab").addClass("active-pack");
	$(".pack-size-swatch-main").removeClass("swatch-visible");
	$(".pack-size-swatch-main .swatch-v-neck-tab").hide();
	$(this).find(".pack-boxes-swatch-main").removeClass("swatch-visible");
});
//collection page size swatches quick shop end


/*pdp sticky bar start*/
$(document).on('click', "button.sticky-scroll", function () {
	scrollToProductOptions()
});

$(document).on('click', 'button#sticky-add-cart', function (e) {
	const currentTarget = e.currentTarget
	const isSelectOptionsMode = currentTarget?.getAttribute('data-select-options-mode')

	isSelectOptionsMode === 'true' ? scrollToProductOptions() : $("button[type='submit'].btn-ajaxcart").click()
})

function scrollToProductOptions() {
	const productOptionsEl = $("#product-options")
	const productOptionsTestEl = $("#product-options-test")

	if (productOptionsEl.length) {
		const offTop = productOptionsEl.offset().top

		$('html,body').animate({
			scrollTop: offTop - 200
		}, 500)
	}
}

/*pdp sticky bar end*/


//stratusoft, fresh clean seas slider
$(".ul-future").slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	dots: true,
	arrows: false,
	infinite: true
});

//klaviyo newsletter start
$("#email_signup #email-address").on('input', function () {
	var email = $.trim($("#email-address").val());
	if (email.length > 0) {
		$(this).parent().siblings('button').addClass('btn-active');
	} else {
		$(this).parent().siblings('button').removeClass('btn-active');
	}
});

$('#email_signup button').on('click', function () {
	var email = $.trim($("#email-address").val());
	var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
	if (!pattern.test(email)) {
		$("#email-error").text("Invalid Email Address").css("color", "#cb4b4b");
		$("#email-error").show();
	}
});
//klaviyo newsletter end


/*cookie size select start*/
function setCookie(name, value, days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}

$(document).on("click", ".color-variant-div", function () {
	document.querySelectorAll(".color-variant-div").forEach(function (e) {
		if (!e.querySelector(".color-divs a")) {
			e.style.display = "none";
		}
	})
})

// our-story team slider on mobile start
$(".team-ul").slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	autoplay: false,
	mobileFirst: true,
	arrows: false,
	dots: true,
	infinite: true,
	variableWidth: false,
	centerMode: true,
	cssEase: 'linear',
	responsive: [
		{
			breakpoint: 767,
			settings: "unslick"
		}
	]
});
// our-story team slider on mobile end

//contact page validation start
$(".contact-form-submit").on("click", function () {
	var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
	var name = $.trim($("#ContactFormName").val());
	var email = $.trim($("#ContactFormEmail").val());
	//var subject = $.trim($("#ContactFormSubject").val());
	var subject = $.trim($("#ContactFormSubject").find("option:selected").attr('disabled'));
	let customFieldsValid = true
	var message = $.trim($("#ContactFormMessage").val());

	if (name.length == 0) {
		$(".error-name").text("Required").fadeIn();
		$(".error-name").parent().css("color", "#cb4b4b");
		$("#ContactFormName").css("border-color", "#cb4b4b");
	} else {
		$(".error-name").text("").fadeOut();
		$(".error-name").parent().css("color", "#242424");
		$("#ContactFormName").css("border-color", "#dbd9d4");
	}

	if (!pattern.test(email) || email.length == 0) {
		$(".error-email").text("Required").fadeIn();
		$(".error-email").parent().css("color", "#cb4b4b");
		$("#ContactFormEmail").css("border-color", "#cb4b4b");
	} else {
		$(".error-email").text("").fadeOut();
		$(".error-email").parent().css("color", "#242424");
		$("#ContactFormEmail").css("border-color", "#dbd9d4");
	}

	if (subject) {
		$(".error-subject").text("Required").fadeIn();
		$(".error-subject").parent().css("color", "#cb4b4b");
		$("#ContactFormSubject").css("border-color", "#cb4b4b");
	} else {
		$(".error-subject").text("").fadeOut();
		$(".error-subject").parent().css("color", "#242424");
		$("#ContactFormSubject").css("border-color", "#dbd9d4");
	}


	$('#ContactFormCustomFields .custom-field').each(function () {
		if ($(this).attr('data-required')) {
			if (!$(this).find('input').val()) {
				$(this).find('.error-state').text("Required").fadeIn()
				$(this).find('.error-state').parent().css("color", "#cb4b4b")
				$(this).find('input').css("border-color", "#cb4b4b")

				customFieldsValid = false
			} else {
				$(this).find('.error-state').text("").fadeOut()
				$(this).find('.error-state').parent().css("color", "#242424")
				$(this).find('input').css("border-color", "#dbd9d4")

				customFieldsValid = true
			}
		}
	});


	if (message.length == 0) {
		$(".error-message").text("Required").fadeIn();
		$(".error-message").parent().css("color", "#cb4b4b");
		$("#ContactFormMessage").css("border-color", "#cb4b4b");
	} else {
		$(".error-message").text("").fadeOut();
		$(".error-message").parent().css("color", "#242424");
		$("#ContactFormMessage").css("border-color", "#dbd9d4");
	}

	if (
		name.length !== 0 &&
		pattern.test(email) &&
		email.length !== 0 &&
		customFieldsValid &&
		!subject && message.length !== 0
	) {
		$(".contact-form-act-submit").click();
	}

});
//contact page validation end

$(document).on('change', 'input[name="filter.p.m.custom.shop_by_style"]', function () {
	const moreBtns = $('[data-more-btn]:checked');
	if (moreBtns.length && document.querySelector('.c-collectionsFilterStyle__button--moreButton') != null) {
		document.querySelector('.c-collectionsFilterStyle__button--moreButton').classList.add('c-collectionsFilterStyle__button--isActiveMoreButton');
	} else {
		document.querySelector('.c-collectionsFilterStyle__button--moreButton').classList.remove('c-collectionsFilterStyle__button--isActiveMoreButton');
	}
})


function ScrollExecute() {

	if ($(document).height() - 1000 < ($(document).scrollTop() + $(window).height()) && $('#view-more').length && window.location.href.includes('/collections/')) {

		scrollNode = $('#view-more').last();
		scrollURL = $('#view-more').last().attr("href");
		changeNode = $('#view-more').last();
		pageNumber = $('#view-more').last().attr("href");
		pageUrl = pageNumber.split('page=')[0];
		pageNumber = parseInt(pageNumber.split('page=')[1]);
		pagesEnd = $('.pagesEnd').text();
		pagesEnd = parseInt(pagesEnd);
		if (pagesEnd >= pageNumber) {
			if (scrollNode.length > 0 && scrollNode.css('display') != 'none') {
				$.ajax({
					type: 'GET',
					url: scrollURL,
					beforeSend: function () {
						scrollNode.hide();
					},
					success: function (data) {
						var filteredData = $(data).find(".product-grid li");
						filteredData.insertBefore($("#product-list-foot"));
						pageNumber++;
						changeNode.attr("href", pageUrl + "page=" + pageNumber.toString());

						changeNode.insertBefore($("#product-list-foot"));
						insertSwatches();
						scrollNode.show();

					},
					dataType: "html"
				});
			}
		}
	}
}

$(document).ready(function () {
	$(window).scroll(function () {
		if (window.location.href.includes('/collections/')) {
			ScrollExecute();
		}

	});
});

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

function customButtonProductSlide() {
	const prevButtonEl = document.querySelector('.custom-slick-button--prev')
	const nextButtonEl = document.querySelector('.custom-slick-button--next')
	const thumbnailSliderEls = document.querySelectorAll('.thumbnail-slider .thumb')
	const debounceWait = window.innerWidth < 500 ? 300 : 0

	if (!prevButtonEl || !nextButtonEl || !thumbnailSliderEls) return

	const thumbnailSliderElsLength = thumbnailSliderEls.length - 1

	function handleClickPrevButton(currentTarget) {
		const slickIndex = Number(currentTarget.getAttribute('data-current-slick-index'))
		const newSlickIndex = slickIndex === 0 ? thumbnailSliderElsLength : slickIndex - 1

		$(".thumbnail-slider .thumb[data-slick-index='" + newSlickIndex + "']").click()

		prevButtonEl.setAttribute('data-current-slick-index', newSlickIndex)
		nextButtonEl.setAttribute('data-current-slick-index', newSlickIndex)
	}

	const debouncedHandleClickPrevButton = debounce(handleClickPrevButton, debounceWait);

	if (prevButtonEl) prevButtonEl.addEventListener('click', e => debouncedHandleClickPrevButton(e.currentTarget))

	function handleClickNextButton(currentTarget) {
		const slickIndex = Number(currentTarget.getAttribute('data-current-slick-index'))
		const newSlickIndex = slickIndex === thumbnailSliderElsLength ? 0 : slickIndex + 1

		$(".thumbnail-slider .thumb[data-slick-index='" + newSlickIndex + "']").click()

		prevButtonEl.setAttribute('data-current-slick-index', newSlickIndex)
		nextButtonEl.setAttribute('data-current-slick-index', newSlickIndex)
	}

	const debouncedHandleClickNextButton = debounce(handleClickNextButton, debounceWait)

	if (nextButtonEl) nextButtonEl.addEventListener('click', e => debouncedHandleClickNextButton(e.currentTarget))
}

customButtonProductSlide()

function handleMembershipButton(event) {
	const membershipAddButtons = document.querySelectorAll('button[data-membership-add-to-cart="true"]')

	if (membershipAddButtons.length) {
		membershipAddButtons.forEach(button => {
			if (event === 'disable') {
				button.disabled = true
				button.innerText = 'ADDED TO CART'
			}

			if (event === 'enable') {
				button.disabled = false
				button.innerText = 'ADD TO CART'
			}
		})
	}
}

function handleCheckoutButton() {
	const checkoutButton = document.querySelector('#checkout-button')

	checkoutButton?.addEventListener('click', () => {
		const loading = checkoutButton.querySelector('#checkout-button-loading')
		const text = checkoutButton.querySelector('#checkout-button-text')

		loading.style.display = 'block'
		text.style.display = 'none'

		checkoutButton.style.pointerEvents = 'none'
	})
}

handleCheckoutButton()

function handleAddToCartLoading(loading = false) {
	const addToCart = document.querySelector('#add-to-cart')
	const addToCartLoading = document.querySelector('#add-to-cart-loading')

	if (loading) {
		if (addToCart) addToCart.style.display = 'none'
		if (addToCartLoading) addToCartLoading.style.display = 'flex'
	}

	if (!loading) {
		if (addToCart) addToCart.style.display = 'block'
		if (addToCartLoading) addToCartLoading.style.display = 'none'
	}

	document.dispatchEvent(new CustomEvent('addToCartLoading', {
		detail: { loading }
	}))
}

function handleSummaryBuildLoading(loading = false) {
	const addToCart = document.querySelector('#summary-build-button') || document.querySelector('#add-to-cart')
	const addToCartLoading = document.querySelector('#summary-build-button-loading') || document.querySelector('#add-to-cart-loading')

	if (loading) {
		if (addToCart) addToCart.style.display = 'none'
		if (addToCartLoading) addToCartLoading.style.display = 'flex'
	}

	if (!loading) {
		if (addToCart) addToCart.style.display = 'block'
		if (addToCartLoading) addToCartLoading.style.display = 'none'
	}

	document.dispatchEvent(new CustomEvent('addToCartLoading', {
		detail: { loading }
	}))
}

function isTablet() {
	return window.innerWidth < 991
}

function isMobile() {
	return window.innerWidth < 491
}

function safariCacheFix() {
	let userAgentString = navigator.userAgent;

	// Detect Chrome
	let chromeAgent = userAgentString.indexOf('Chrome') > -1;

	// Detect Safari
	let safariAgent = userAgentString.indexOf('Safari') > -1;

	// Discard Safari since it also matches Chrome
	if (chromeAgent && safariAgent) safariAgent = false;

	if (safariAgent) { // only for Safari, if the page is cached, reload it
		window.onpageshow = function (event) {
			if (event.persisted) window.location.reload()
		}
	}
}

safariCacheFix()

function initSlick(id = '', options = {}) {
	$(id).slick(options)
}

window.initSlick = initSlick

function collectionCategoriesSlick() {
	if (isMobile()) {
		$(".collection-categories-slide-ul").slick({
			infinite: false,
			slidesToShow: 2,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			cssEase: 'linear',
			variableWidth: false,
			centerMode: false,
			touchThreshold: 100
		})
	}
}

collectionCategoriesSlick()


function productVariantsHandler(initOptions, product, method) {
	const variants = product.variants

	if (!initOptions || !variants) return false

	return variants[method](variant => {
		let result = false

		if (initOptions['option1']) {
			result = handleVariant(variant.option1) === initOptions['option1']
		}

		if (initOptions['option1'] && initOptions['option2']) {
			result =
				handleVariant(variant.option1) === initOptions['option1'] &&
				handleVariant(variant.option2) === initOptions['option2']
		}

		if (initOptions['option1'] && initOptions['option2'] && initOptions['option3']) {
			result =
				handleVariant(variant.option1) === initOptions['option1'] &&
				handleVariant(variant.option2) === initOptions['option2'] &&
				handleVariant(variant.option3) === initOptions['option3']
		}

		return result
	})

	function handleVariant(variant) {
		return variant?.replace('\"', '')
	}
}

window.productVariantsHandler = productVariantsHandler


function reinitializingScript(selector = '') {
	const el = document.querySelector(selector)

	if (el) {
		const oldScript = el.querySelector('script')

		if (oldScript) {
			const scriptContent = oldScript.innerHTML

			oldScript.parentNode.removeChild(oldScript)

			const newScript = document.createElement('script')
			newScript.text = scriptContent

			el.appendChild(newScript)
		}
	}
}

window.reinitializingScript = reinitializingScript
